<template>
	<div class="file_bg">
		<div v-if="fileList.length > 0" class="pre_bg">
			<div v-for="(item, index) in fileList" :key="index" class="pre_item">
				<div class="pre_img">
					<span>{{ item.fileType }}</span>
					<i class="el-icon-delete pre_delete" @click.stop="removeFile(index)"></i>
				</div>
				<div class="pre_name">{{ item.name }}</div>
			</div>
		</div>
		<el-upload
			ref="upload"
			class="upload-demo"
			name="File"
			:accept="acceptParm"
			:action="uploadUrl"
			:headers="myHeaders"
			:before-upload="handleBeforeUpload"
			:on-success="handleSuccess"
			:on-error="handleUploadError"
			:on-exceed="handleExceed"
			:file-list="showFileList"
			:multiple="false"
			:limit="fileLimit"
			:show-file-list="false"
		>
			<el-button size="small" type="primary">上传文件</el-button>
		</el-upload>
	</div>
</template>
<script>
export default {
	name: "ChunkUpload",
	props: {
		// 已上传的文件列表 (v-model)
		value: {
			type: Array,
			default: () => []
		},
		// 文件类型限制，例如 ".zip,.rar,.7z"
		acceptParm: {
			type: String,
			default: ".zip,.rar,.7z"
		},
		// 最大上传个数
		fileLimit: {
			type: Number,
			default: 1
		},
		// 单个文件大小限制(MB)
		fileSize: {
			type: Number,
			default: 200
		}
	},
	data() {
		return {
			uploadUrl: "/api/sysConfig/FileManager/SaveAttachmentList",
			fileList: [],
			myHeaders: {},
			uploading: false
		};
	},
	computed: {
		// 用于 el-upload 内部展示（这里关闭自带的列表，仅用于引用）
		showFileList() {
			return this.fileList.map((item) => ({ name: item.name }));
		}
	},
	watch: {
		value: {
			handler(newVal) {
				this.fileList = JSON.parse(JSON.stringify(newVal || []));
			},
			immediate: true,
			deep: true
		}
	},
	created() {
		this.getToken();
	},
	methods: {
		// 获取 token
		getToken() {
			const token = localStorage.getItem("logintoken");
			this.myHeaders = {
				Authorization: "Bearer " + token
			};
		},
		// 上传前校验格式和大小
		handleBeforeUpload(file) {
			const fileExtension = file.name.indexOf(".") > -1 ? file.name.slice(file.name.lastIndexOf(".")).toLowerCase() : "";
			if (this.acceptParm) {
				const acceptList = this.acceptParm.split(",").map((item) => item.trim().toLowerCase()).filter(Boolean);
				if (acceptList.length > 0 && acceptList.indexOf(fileExtension) === -1) {
					this.$message.error(`文件格式不正确，请上传${this.acceptParm}格式文件!`);
					return false;
				}
			}
			if (this.fileSize && file.size / 1024 / 1024 > this.fileSize) {
				this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
				return false;
			}
			if (this.fileList.length >= this.fileLimit) {
				this.$message.error("超出上传文件个数，请删除后再上传！");
				return false;
			}
			return true;
		},
		handleUploadError() {
			this.uploading = false;
			this.$message.error("上传失败，请重试");
		},
		// 超过个数
		handleExceed() {
			this.$message.error(`超出上传文件个数，请删除后再上传！`);
		},
		// 上传成功
		handleSuccess(res, file) {
			this.uploading = false;
			if (res.code === 1 && res.data && res.data.length > 0) {
				const data = res.data[0];
				const postFix = data.postFix || (file.name.indexOf(".") > -1 ? file.name.slice(file.name.lastIndexOf(".")) : "");
				const tempItem = {
					name: file.name,
					url: data.filePath,
					keyId: data.keyId,
					fileType: postFix,
					fileSize: this.convertBytesToSize(data.fileSize),
					createTime: data.createTime
				};
				this.fileList.push(tempItem);
				this.changeFileList();
				this.$message.success("上传成功");
			} else {
				this.$message.info(res.msg || "上传失败");
			}
		},
		// 删除文件
		removeFile(index) {
			this.fileList.splice(index, 1);
			this.changeFileList();
			this.$message.success("删除成功");
		},
		// 文件列表变化，更新 v-model
		changeFileList() {
			this.$emit("input", JSON.parse(JSON.stringify(this.fileList)));
		},
		// 文件大小转换
		convertBytesToSize(bytes) {
			if (!bytes) return "0 B";
			const BYTES_IN_KILOBYTES = 1024;
			const BYTES_IN_MEGABYTES = 1048576;
			const BYTES_IN_GIGABYTES = 1073741824;
			if (bytes < BYTES_IN_KILOBYTES) {
				return `${bytes} B`;
			} else if (bytes < BYTES_IN_MEGABYTES) {
				return `${(bytes / BYTES_IN_KILOBYTES).toFixed(2)} KB`;
			} else if (bytes < BYTES_IN_GIGABYTES) {
				return `${(bytes / BYTES_IN_MEGABYTES).toFixed(2)} MB`;
			}
			return `${(bytes / BYTES_IN_GIGABYTES).toFixed(2)} GB`;
		}
	}
};
</script>
<style scoped>
.file_bg {
	display: flex;
	flex-direction: column;
}

.pre_bg {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: 20px;
}

.pre_item {
	width: 120px;
	margin-right: 10px;
	margin-bottom: 10px;
}

.pre_item .pre_img {
	width: 100%;
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid var(--app-primary-hover);
	color: var(--app-primary-hover);
	border-radius: 10px;
	position: relative;
	padding: 5px;
}

.pre_item .pre_delete {
	position: absolute;
	top: 0;
	right: 0;
	color: var(--app-danger);
	font-size: 18px;
	cursor: pointer;
}

.pre_item .pre_name {
	font-size: 12px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
</style>